module.exports = __webpack_public_path__ + "img/bespoke70_08.35d3abf9.jpg";